/* PixelCharm theme scripts */
(function () {
  'use strict';
  var PC = window.PC || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || PC.moneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelims(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      default: value = withDelims(cents, 2);
    }
    return match ? format.replace(match[0], value) : value;
  }
  PC.formatMoney = formatMoney;

  /* ---------- 8-bit blip ---------- */
  var audioCtx;
  function blip() {
    if (!PC.sounds) return;
    try {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
      var o = audioCtx.createOscillator(), g = audioCtx.createGain();
      o.type = 'square'; o.connect(g); g.connect(audioCtx.destination);
      var t = audioCtx.currentTime;
      o.frequency.setValueAtTime(660, t); o.frequency.setValueAtTime(990, t + 0.07); o.frequency.setValueAtTime(1320, t + 0.14);
      g.gain.setValueAtTime(0.06, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.25);
      o.start(t); o.stop(t + 0.26);
    } catch (e) {}
  }

  /* ---------- Background sparkles ---------- */
  function initStars() {
    var canvas = document.getElementById('pc-stars');
    if (!canvas || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = canvas.getContext('2d');
    var colors = ['#22f0ff', '#a855f7', '#ff8bf0', '#ffffff', '#ffd23f'];
    var stars = [], w, h;
    function resize() {
      w = canvas.width = window.innerWidth; h = canvas.height = window.innerHeight;
      var count = Math.min(70, Math.floor(w * h / 22000));
      stars = [];
      for (var i = 0; i < count; i++) {
        stars.push({ x: Math.random() * w, y: Math.random() * h, s: Math.random() < 0.2 ? 4 : 2, c: colors[i % colors.length], p: Math.random() * Math.PI * 2, v: 0.15 + Math.random() * 0.35 });
      }
    }
    function frame() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < stars.length; i++) {
        var st = stars[i];
        st.p += 0.03; st.y -= st.v;
        if (st.y < -10) { st.y = h + 10; st.x = Math.random() * w; }
        var a = (Math.sin(st.p) + 1) / 2;
        ctx.globalAlpha = 0.15 + a * 0.6;
        ctx.fillStyle = st.c;
        var x = Math.round(st.x / 2) * 2, y = Math.round(st.y / 2) * 2;
        ctx.fillRect(x, y, st.s, st.s);
        if (st.s === 4 && a > 0.7) { ctx.fillRect(x - 4, y + 1, 2, 2); ctx.fillRect(x + 6, y + 1, 2, 2); ctx.fillRect(x + 1, y - 4, 2, 2); ctx.fillRect(x + 1, y + 6, 2, 2); }
      }
      requestAnimationFrame(frame);
    }
    resize(); window.addEventListener('resize', resize); frame();
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var btn = $('[data-menu-toggle]'), menu = $('[data-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', function (e) {
      if (menu.classList.contains('is-open') && !menu.contains(e.target) && !btn.contains(e.target)) {
        menu.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(text) {
    var el = $('#pc-toast'); if (!el) return;
    $('#pc-toast-text').textContent = text;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Cart drawer ---------- */
  var drawer = null;
  function openDrawer() {
    if (!drawer) return false;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return true;
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawer) return;
    var wrap = $('[data-cart-items]', drawer);
    if (!cart.items.length) {
      wrap.innerHTML = '<p class="pc-drawer__empty">Your inventory is empty.</p>';
    } else {
      wrap.innerHTML = cart.items.map(function (item, i) {
        var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="72" height="72" loading="lazy">' : '<span></span>';
        var variant = item.variant_title && item.product_has_only_default_variant === false ? '<p class="pc-ditem__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
        var was = item.original_line_price !== item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
        return '<div class="pc-ditem">' + img +
          '<div><p class="pc-ditem__title">' + escapeHtml(item.product_title) + '</p>' + variant +
          '<div class="pc-ditem__qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease">−</button><span>' + item.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
          '<div class="pc-ditem__price">' + was + formatMoney(item.final_line_price) + '</div></div>';
      }).join('');
    }
    var sub = $('[data-cart-subtotal]', drawer); if (sub) sub.textContent = formatMoney(cart.total_price);
    updateXp(cart.total_price);
  }

  function updateXp(total) {
    var xp = drawer && $('[data-xp]', drawer);
    var threshold = PC.freeShippingThreshold || 0;
    if (!xp || !threshold) return;
    var pct = Math.min(100, Math.round(total / threshold * 100));
    $('[data-xp-fill]', xp).style.width = pct + '%';
    var remaining = threshold - total;
    $('[data-xp-text]', xp).textContent = remaining > 0
      ? (PC.freeShippingText || '').replace('[amount]', formatMoney(remaining))
      : (PC.freeShippingDoneText || '');
  }

  function fetchCart() {
    return fetch((PC.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity) {
    return fetch((PC.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function initDrawer() {
    drawer = document.getElementById('pc-cart-drawer');
    $$('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (!drawer || document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        fetchCart().then(renderCart); openDrawer();
      });
    });
    $$('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        var b = e.target.closest('[data-line]');
        if (b) changeLine(parseInt(b.dataset.line, 10), parseInt(b.dataset.q, 10));
      });
      fetchCart().then(renderCart).catch(function () {});
    }
  }

  /* ---------- Product page ---------- */
  var SWATCHES = {
    white: '#eaf4ff', frost: '#eaf4ff', blue: '#2f6bff', mana: '#2f6bff', navy: '#1e3a8a', cyan: '#22f0ff', aqua: '#22f0ff', sky: '#5ec8ff', teal: '#14b8a6',
    green: '#22d36b', emerald: '#22d36b', lime: '#a3e635', yellow: '#ffd23f', gold: '#ffb627', orange: '#ff8c1a', red: '#ff2d3d', ruby: '#ff2d3d',
    pink: '#ff8bf0', purple: '#a855f7', violet: '#8b5cf6', black: '#111111', rainbow: 'linear-gradient(90deg,#ff2d3d,#ffd23f,#22d36b,#22f0ff,#2f6bff,#a855f7)', multi: 'linear-gradient(90deg,#ff2d3d,#ffd23f,#22d36b,#22f0ff,#2f6bff,#a855f7)'
  };
  function swatchFor(name) {
    var n = String(name || '').toLowerCase();
    for (var k in SWATCHES) { if (n.indexOf(k) > -1) return SWATCHES[k]; }
    return null;
  }

  function initProduct(section) {
    var dataEl = $('[data-product-json]', section);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var form = $('[data-product-form]', section);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var qtyInput = form ? $('[data-qty-input]', form) : null;
    var addBtn = form ? $('[data-add-btn]', form) : null;
    var addText = addBtn ? $('[data-add-text]', addBtn) : null;
    var defaultAddText = addText ? addText.textContent : 'Add to cart';
    var current = variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];

    // Swatch colors
    $$('[data-swatch]', section).forEach(function (sw) {
      var c = swatchFor(sw.dataset.swatch);
      if (c) sw.style.setProperty('--sw', c);
      if (c && c.indexOf('gradient') > -1) sw.style.background = c;
    });

    // Gallery
    var slides = $$('.pc-gallery__slide', section), thumbs = $$('[data-thumb]', section), idx = 0;
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.thumb, 10)); }); });
    var prev = $('[data-gallery-prev]', section), next = $('[data-gallery-next]', section);
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    var main = $('.pc-gallery__main', section), sx = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); sx = null; });
    }

    // Variant picker
    var picker = $('[data-variant-picker]', section);
    function selectedOptions() {
      var opts = [];
      $$('input[data-option-index]:checked', section).forEach(function (inp) { opts[parseInt(inp.dataset.optionIndex, 10)] = inp.value; });
      return opts;
    }
    function updateAvailability() {
      var sel = selectedOptions();
      $$('input[data-option-index]', section).forEach(function (inp) {
        var oi = parseInt(inp.dataset.optionIndex, 10);
        var test = sel.slice(); test[oi] = inp.value;
        var ok = variants.some(function (v) { return v.available && v.options.every(function (o, n) { return test[n] === undefined || o === test[n]; }); });
        inp.classList.toggle('is-unavailable', !ok);
      });
    }
    function setVariant(v) {
      current = v;
      if (idInput) idInput.value = v ? v.id : '';
      if (addBtn) {
        addBtn.disabled = !v || !v.available;
        if (addText) addText.textContent = !v ? 'Unavailable' : (v.available ? defaultAddText : 'Sold out');
      }
      var sticky = $('[data-sticky-add]', section); if (sticky) sticky.disabled = !v || !v.available;
      if (!v) return;
      // price
      $$('[data-price-wrap]', section).forEach(function (w) {
        $('[data-price]', w).textContent = formatMoney(v.price);
        var cmp = $('[data-compare]', w), badge = $('[data-save-badge]', w);
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        w.classList.toggle('is-sale', !!sale);
        if (cmp) { cmp.hidden = !sale; cmp.textContent = sale ? formatMoney(v.compare_at_price) : ''; }
        if (badge) { badge.hidden = !sale; badge.textContent = sale ? '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : ''; }
      });
      var sp = $('[data-sticky-price]', section); if (sp) sp.textContent = formatMoney(v.price);
      // media
      if (v.featured_media) {
        var target = slides.findIndex(function (s) { return s.dataset.mediaId === String(v.featured_media.id); });
        if (target > -1) show(target);
      }
      // labels
      v.options.forEach(function (o, n) { var l = $('[data-option-label="' + n + '"]', section); if (l) l.textContent = o; });
      updateTiers();
      // URL
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
    }
    if (picker) {
      picker.addEventListener('change', function () {
        var sel = selectedOptions();
        var v = variants.find(function (vv) { return vv.options.every(function (o, n) { return o === sel[n]; }); });
        setVariant(v || null);
        updateAvailability();
      });
      updateAvailability();
    }

    // Bundle tiers
    var bundle = $('[data-bundle]', section);
    function updateTiers() {
      if (!bundle || !current) return;
      $$('.pc-tier', bundle).forEach(function (t) {
        var inp = $('input', t), q = parseInt(inp.dataset.qty, 10), d = parseInt(inp.dataset.discount, 10) || 0;
        var full = current.price * q, pay = Math.round(full * (100 - d) / 100);
        var p = $('[data-tier-pay]', t), f = $('[data-tier-full]', t);
        if (p) p.textContent = formatMoney(pay);
        if (f) f.textContent = formatMoney(full);
      });
    }
    if (bundle) {
      bundle.addEventListener('change', function (e) {
        if (!e.target.matches('input')) return;
        $$('.pc-tier', bundle).forEach(function (t) { t.classList.toggle('is-selected', $('input', t).checked); });
        if (qtyInput) qtyInput.value = e.target.dataset.qty;
        blip();
      });
      var first = $('input:checked', bundle); if (first && qtyInput) qtyInput.value = first.dataset.qty;
    }

    // Quantity buttons
    var minus = $('[data-qty-minus]', section), plus = $('[data-qty-plus]', section);
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    // Add to cart
    if (form && drawer) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        var err = $('[data-form-error]', form); if (err) err.hidden = true;
        addBtn.classList.add('is-loading');
        var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
        fetch((PC.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: current.id, quantity: qty }] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return fetchCart(); })
          .then(function (cart) {
            renderCart(cart); blip();
            toast(qty + ' × ' + (current.name || 'item') + ' added to your inventory');
            $$('.pc-cart-btn').forEach(function (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
            setTimeout(openDrawer, 350);
          })
          .catch(function (j) { if (err) { err.textContent = (j && (j.description || j.message)) || 'Something went wrong. Try again.'; err.hidden = false; } })
          .then(function () { addBtn.classList.remove('is-loading'); });
      });
    }

    // Sticky ATC
    var stickyBar = $('[data-sticky-atc]', section);
    if (stickyBar && addBtn) {
      var stickyAdd = $('[data-sticky-add]', stickyBar);
      stickyAdd.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', show); stickyBar.setAttribute('aria-hidden', !show);
        });
      });
      io.observe(addBtn);
    }
  }

  /* ---------- Countdown ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.countdown.replace(' ', 'T')).getTime();
      var out = $('[data-countdown-time]', el);
      function tick() {
        var d = end - Date.now();
        if (d <= 0) { el.hidden = true; return; }
        var days = Math.floor(d / 864e5), h = Math.floor(d / 36e5) % 24, m = Math.floor(d / 6e4) % 60, s = Math.floor(d / 1e3) % 60;
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        out.textContent = (days ? days + 'D ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* ---------- Color showcase ---------- */
  function initShowcase() {
    $$('[data-color-showcase]').forEach(function (sec) {
      var stage = $('[data-stage]', sec), name = $('[data-stage-name]', sec), mood = $('[data-stage-mood]', sec);
      var chips = $$('.pc-colors__chip', sec);
      function pick(chip) {
        chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-checked', on); });
        stage.style.setProperty('--glow', chip.dataset.color);
        name.textContent = chip.dataset.name; mood.textContent = chip.dataset.mood;
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { pick(c); blip(); }); });
      if (chips[0]) stage.style.setProperty('--glow', chips[0].dataset.color);
    });
    // Hero mini potion color cycle
    var cycle = $('[data-color-cycle]');
    if (cycle) {
      var cols = ['#22f0ff', '#2f6bff', '#a855f7', '#ff8bf0', '#ffd23f', '#22d36b', '#ff2d3d'], i = 0;
      var svg = $('svg', cycle);
      setInterval(function () { i = (i + 1) % cols.length; svg.style.setProperty('--liquid', cols[i]); cycle.style.setProperty('--liquid-glow', cols[i]); }, 1600);
    }
  }

  /* ---------- Related products (lazy) ---------- */
  function initRelated() {
    $$('[data-related]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-related]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; reveal(el); }
      }).catch(function () {});
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealObs = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealObs.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;
  function reveal(root) {
    if (!revealObs) return;
    $$('.pc-feature, .pc-card, .pc-review, .pc-iwt__media, .pc-colors__stage, .pc-faq .pc-acc', root).forEach(function (el, i) {
      if (el.classList.contains('pc-reveal')) return;
      el.classList.add('pc-reveal'); el.style.transitionDelay = (i % 4) * 80 + 'ms'; revealObs.observe(el);
    });
  }

  /* ---------- Secret code easter egg ---------- */
  function initEgg() {
    if (!PC.easterEgg) return;
    var seq = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'], pos = 0;
    document.addEventListener('keydown', function (e) {
      var k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      pos = k === seq[pos] ? pos + 1 : (k === seq[0] ? 1 : 0);
      if (pos === seq.length) {
        pos = 0; document.body.classList.toggle('pc-rainbow'); blip();
        toast(document.body.classList.contains('pc-rainbow') ? 'Rainbow mode activated!' : 'Rainbow mode off');
      }
    });
  }

  /* ---------- Recover password toggle ---------- */
  function initRecover() {
    var t = $('[data-recover-toggle]'), box = $('#recover');
    if (!t || !box) return;
    if (!window.location.hash.includes('recover') && !box.querySelector('.pc-success, .errors')) box.hidden = true;
    t.addEventListener('click', function (e) { e.preventDefault(); box.hidden = !box.hidden; });
  }

  function init() {
    initStars(); initMenu(); initDrawer();
    $$('[data-product-section]').forEach(initProduct);
    initCountdowns(); initShowcase(); initRelated(); reveal(document); initEgg(); initRecover();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProduct);
    initCountdowns(); initShowcase(); reveal(e.target);
  });
})();
